import { createAction, props } from '@ngrx/store';
import { OutletGroups } from 'app/interfaces';

export const resetAdvancedSearchFilters = createAction(
  '[Advanced Search] resetSearch',
  props<{ onResetFilters: boolean }>()
);

export const setAdvancedFilterText = createAction(
  '[Advanced Search] setAdvancedFilterText',
  props<{ filterText: string }>()
);

export const unSetAdvancedFilterText = createAction(
  '[Advanced Search] unSetAdvancedFilterText'
);

export const setOutletGroups = createAction(
  '[Advanced Search] setOutletGroups',
  props<{ outletGroups: OutletGroups[] }>()
);
